
import { Link } from 'react-router-dom';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

const HowWeWorkPage = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F4EF' }}>
      <Navigation />
      
      {/* Breadcrumbs */}
      <section className="pt-24 pb-4">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
            <Link 
              to="/" 
              className="transition-colors duration-200 cursor-pointer hover:opacity-80"
              style={{ color: '#7B6655' }}
            >
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-500">Services</span>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="font-medium">How We Work</span>
          </nav>
        </div>
      </section>
      
      {/* Hero Section */}
      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 
            className="text-5xl lg:text-6xl font-bold mb-6"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            How We Work
          </h1>
          <p 
            className="text-2xl mb-10 max-w-3xl mx-auto"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            A structured, proven implementation framework that takes organizations from manual chaos to automated clarity.
          </p>
          <button
            onClick={scrollToContact}
            className="inline-flex items-center px-8 py-4 rounded-lg font-semibold text-white text-lg transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#7B6655' }}
          >
            Schedule Workflow Audit
            <i className="ri-calendar-line ml-2"></i>
          </button>
        </div>
      </section>

      {/* Implementation Process */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <h2 
            className="text-4xl font-bold text-center mb-16"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Our Implementation Process
          </h2>
          
          {/* Timeline */}
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute top-16 left-0 right-0 h-1 hidden lg:block" style={{ backgroundColor: '#E6DACD' }}></div>
            
            {/* Timeline Steps */}
            <div className="grid lg:grid-cols-5 gap-8 lg:gap-4">
              {/* Step 1 */}
              <div className="text-center relative">
                <div className="w-12 h-12 mx-auto mb-6 rounded-full flex items-center justify-center text-white font-bold text-lg relative z-10" style={{ backgroundColor: '#7B6655' }}>
                  1
                </div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Workflow Audit & Discovery
                </h3>
                <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Map current processes and identify inefficiencies.
                </p>
              </div>

              {/* Step 2 */}
              <div className="text-center relative">
                <div className="w-12 h-12 mx-auto mb-6 rounded-full flex items-center justify-center text-white font-bold text-lg relative z-10" style={{ backgroundColor: '#7B6655' }}>
                  2
                </div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  System Architecture Blueprint
                </h3>
                <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Design the operational structure and automation framework.
                </p>
              </div>

              {/* Step 3 */}
              <div className="text-center relative">
                <div className="w-12 h-12 mx-auto mb-6 rounded-full flex items-center justify-center text-white font-bold text-lg relative z-10" style={{ backgroundColor: '#7B6655' }}>
                  3
                </div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Build & Integration
                </h3>
                <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Implement workflows, CRM layers, automation logic, and communication systems.
                </p>
              </div>

              {/* Step 4 */}
              <div className="text-center relative">
                <div className="w-12 h-12 mx-auto mb-6 rounded-full flex items-center justify-center text-white font-bold text-lg relative z-10" style={{ backgroundColor: '#7B6655' }}>
                  4
                </div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Staff Training & Rollout
                </h3>
                <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Conduct training, provide documentation, and support adoption.
                </p>
              </div>

              {/* Step 5 */}
              <div className="text-center relative">
                <div className="w-12 h-12 mx-auto mb-6 rounded-full flex items-center justify-center text-white font-bold text-lg relative z-10" style={{ backgroundColor: '#7B6655' }}>
                  5
                </div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Ongoing Optimization
                </h3>
                <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Continuous improvements as the organization scales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Automation Flow Diagram */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <h2 
            className="text-4xl font-bold text-center mb-16"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Visual Automation Flow
          </h2>
          
          {/* Flow Diagram */}
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-sm border" style={{ borderColor: '#E6DACD' }}>
            <div className="flex flex-col lg:flex-row items-center justify-between space-y-8 lg:space-y-0 lg:space-x-6">
              
              {/* Manual Inputs */}
              <div className="text-center flex-1">
                <div className="w-16 h-16 mx-auto mb-4 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                  <i className="ri-user-line text-2xl" style={{ color: '#7B6655' }}></i>
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Manual Inputs
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Client inquiries, forms, emails
                </p>
              </div>

              {/* Arrow */}
              <div className="hidden lg:block">
                <i className="ri-arrow-right-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <div className="lg:hidden">
                <i className="ri-arrow-down-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>

              {/* Intake Automation */}
              <div className="text-center flex-1">
                <div className="w-16 h-16 mx-auto mb-4 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                  <i className="ri-settings-3-line text-2xl" style={{ color: '#7B6655' }}></i>
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Intake Automation
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Automated capture & routing
                </p>
              </div>

              {/* Arrow */}
              <div className="hidden lg:block">
                <i className="ri-arrow-right-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <div className="lg:hidden">
                <i className="ri-arrow-down-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>

              {/* CRM Sync */}
              <div className="text-center flex-1">
                <div className="w-16 h-16 mx-auto mb-4 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                  <i className="ri-database-2-line text-2xl" style={{ color: '#7B6655' }}></i>
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  CRM Sync
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Data organization & tracking
                </p>
              </div>

              {/* Arrow */}
              <div className="hidden lg:block">
                <i className="ri-arrow-right-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <div className="lg:hidden">
                <i className="ri-arrow-down-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>

              {/* Notifications */}
              <div className="text-center flex-1">
                <div className="w-16 h-16 mx-auto mb-4 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                  <i className="ri-notification-3-line text-2xl" style={{ color: '#7B6655' }}></i>
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Notifications
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Team alerts & updates
                </p>
              </div>

              {/* Arrow */}
              <div className="hidden lg:block">
                <i className="ri-arrow-right-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <div className="lg:hidden">
                <i className="ri-arrow-down-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>

              {/* Dashboards */}
              <div className="text-center flex-1">
                <div className="w-16 h-16 mx-auto mb-4 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                  <i className="ri-dashboard-3-line text-2xl" style={{ color: '#7B6655' }}></i>
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Dashboards
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Real-time visibility
                </p>
              </div>

              {/* Arrow */}
              <div className="hidden lg:block">
                <i className="ri-arrow-right-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <div className="lg:hidden">
                <i className="ri-arrow-down-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>

              {/* Reporting & Insights */}
              <div className="text-center flex-1">
                <div className="w-16 h-16 mx-auto mb-4 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                  <i className="ri-bar-chart-box-line text-2xl" style={{ color: '#7B6655' }}></i>
                </div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                  Reporting & Insights
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Performance analytics
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Summary */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h2 
            className="text-4xl font-bold text-center mb-16"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Key Benefits
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
              <div className="w-12 h-12 mb-6 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                <i className="ri-eye-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                Operational Clarity
              </h3>
              <p style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                Clear visibility into every process, bottleneck, and opportunity for improvement across your organization.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
              <div className="w-12 h-12 mb-6 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                <i className="ri-hand-heart-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                Reduced Manual Work
              </h3>
              <p style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                Eliminate repetitive tasks and free your team to focus on high-value activities that drive growth.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
              <div className="w-12 h-12 mb-6 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                <i className="ri-message-3-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                Improved Communication Flow
              </h3>
              <p style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                Seamless information flow between teams, departments, and external stakeholders.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
              <div className="w-12 h-12 mb-6 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#F8F4EF' }}>
                <i className="ri-rocket-line text-2xl" style={{ color: '#7B6655' }}></i>
              </div>
              <h3 className="text-xl font-bold mb-4" style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}>
                Scalable Infrastructure
              </h3>
              <p style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                Systems that grow with your organization, supporting expansion without operational chaos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div id="contact-section" className="text-center bg-white p-12 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
            <h2 
              className="text-3xl font-bold mb-6"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Start With a Workflow Audit
            </h2>
            <p 
              className="text-xl mb-8 max-w-2xl mx-auto"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              Ready to transform your operations? Begin with a comprehensive workflow audit to map your current processes and identify automation opportunities.
            </p>
            <button
              className="inline-flex items-center px-8 py-4 rounded-lg font-semibold text-white text-lg transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#7B6655' }}
            >
              Schedule Your Workflow Audit
              <i className="ri-calendar-line ml-2"></i>
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HowWeWorkPage;
